module.exports = __webpack_public_path__ + "static/media/handgift.b59ff103.gif";